<script lang="ts">
  import { searchFilter, searchParams } from "state/page";
  import DateFilter from "./DateFilter.svelte";
  import PhotographerFilter from "./PhotographerFilter.svelte";
  import TagsFilter from "./TagsFilter.svelte";
  import RightsFilter from "./RightsFilter.svelte";
  import NtbFilter from "./NtbFilter.svelte";
  import ImageTypeFilter from "./ImageTypeFilter.svelte";
  import SourceSystemFilter from "./SourceSystemFilter.svelte";
  import NrkFilter from "./NrkFilter.svelte";
  import UsageDomainFilter from "./UsageDomainFilter.svelte";
  import { useFeatureToggle } from "../../services/configCatService";
  import MyImagesFilter from "./MyImagesFilter.svelte";
</script>

<div id="filter-container" class="filter-container">
  <div class="filter-element">
    <button type="button">Hurtigfiltere</button>
    <bb-expand hidden={false} class="important-filters">
      <div class:active-filter={$searchFilter.nrkImages}>
        <NrkFilter />
      </div>
      <div class:active-filter={$searchFilter.ntbCuratedImages}>
        <NtbFilter />
      </div>
      <div class:active-filter={$searchParams.owner}>
        <MyImagesFilter />
      </div>
    </bb-expand>
  </div>
  <div class:active-filter={$searchFilter.rightsMarker?.length} class="filter-element">
    <RightsFilter />
  </div>
  <div class:active-filter={$searchFilter.photographer} class="filter-element">
    <PhotographerFilter />
  </div>
  <div class:active-filter={$searchFilter.tags?.length} class="filter-element">
    <TagsFilter />
  </div>
  <div class:active-filter={$searchFilter.date} class="filter-element">
    <DateFilter />
  </div>
  <div class:active-filter={$searchFilter.sourceSystems?.length} class="filter-element">
    <SourceSystemFilter />
  </div>
  <div class:active-filter={$searchFilter.digitalSourceTypeGroups?.length} class="filter-element">
    <ImageTypeFilter />
  </div>
  {#await useFeatureToggle("usageDomain") then featureEnabled}
    {#if featureEnabled}
      <div class:active-filter={$searchFilter.usageDomains?.length} class="filter-element">
        <UsageDomainFilter />
      </div>
    {/if}
  {/await}
</div>

<style>
  .filter-container {
    margin: 0 0 var(--org-xsmall);
    padding: 0;
    min-width: 250px;
    display: flex;
    flex-direction: column;
    position: relative;
    transition:
      opacity 0.2s,
      height 0.3s;
  }

  .filter-element {
    padding: 0 var(--org-xsmall) var(--org-xsmall);
    position: relative;
  }

  .filter-element :global(bb-expand) {
    padding: var(--org-small);
  }

  .active-filter {
    background: var(--org-color-shade-1);
  }

  .important-filters {
    display: flex;
    flex-direction: column;
    gap: var(--org-xsmall);
  }
</style>
